module.exports = __webpack_public_path__ + "img/select-client.92dd8bb9.png";